import { GQL_PaycheckLineCalculationTypeEnum } from '@/queries/global';
import Decimal from '@/utils/decimal';
import { Dayjs } from 'dayjs';

interface IPaycheckReady {
  lockedAt: Dayjs | null;
  isSentToAltinn: boolean;
  shouldSendToAltinn: boolean;
}

export function sumCorrectPaycheckLines(lines: {
  sum: Decimal;
  calculationType?: GQL_PaycheckLineCalculationTypeEnum;
}[]): Decimal {
  return lines
    .filter(line => line.calculationType === GQL_PaycheckLineCalculationTypeEnum.CASHEDOUT)
    .reduce((sum, line) => sum.add(line.sum), new Decimal(0));
}

export function paycheckReadyForAmelding(paycheck: IPaycheckReady) {
  return paycheck.lockedAt && !paycheck.isSentToAltinn && paycheck.shouldSendToAltinn;
}

// Based on Amelding rules F504 and F505
export const MAXIMUM_LINE_QUANTITY = new Decimal(300);
export const MAXIMUM_LINE_RATE = new Decimal(10000);
